import { MultiSelect } from '../../input';
import { Error } from '../../error';
import { includeContentOptions } from '../../../constants';

export const IncludeInput = ({ params, onChange, errors }) => (
  <>
    <MultiSelect
      label="Include"
      value={params.include}
      onChange={(val) => onChange('include', val)}
      choices={includeContentOptions}
    />
    <Error message={errors?.include} />
  </>
);
